<template>
<article>  
  <section>
     <div class="container">
       <div class="content">
             <br/><h2 class="title is-3">Hello, {{personal.name || "Unnamed Person"}}!</h2>

             <h3>Here's everything we know about you:</h3>
             <blockquote>
               <span v-for="k in Object.keys(personal).reverse()" v-if="!k.startsWith('.')">
                 <b>{{k}}:</b> {{personal[k]}}<br/>
               </span>
             </blockquote>
             ummm... that's it.

             <h2 class="title is-3">Your orders:</h2>
             <span v-if="!purchasesByDate.length">No orders yet!</span>
             <order-card v-for="p in purchasesByDate" :oid="p['.key']"
                         :key="p['.key']"/>
       </div>
     </div>
  </section>

  <section id="padding">
    <div class="container box">
      <index-launcher title="Now let's make more books!"/>
    </div>
  </section>
  
</article>
</template>

<script>
import OrderCard from './OrderCard'
import IndexLauncher from '@/components/IndexLauncher'
import Firebase from '../firebase.js'
var db = Firebase.database

export default {
  name: 'MyAccountPage',
  components: {
    OrderCard,
    IndexLauncher,
  },
  data: function() { return {
  }},
  firebase: function() {
    return {
      purchases: {
        source: db.ref('/purchases/'+this.$store.state.uid),
        },
      personal: {
        source: db.ref('/users/'+this.$store.state.uid+'/personal'),
        asObject: true },
    }
  },
  computed: {
    purchasesByDate: function() {
      return this.purchases.concat().reverse()
    },
  },
  mounted: function() {
    if (this.$route.params.email) {
      console.log('for account:', this.$route.params.email)
      db.ref('/users').orderByChild('personal/email')
        .equalTo(this.$route.params.email)
        .once('value').then(snap => {
          var userinfo = snap.val()
          if (userinfo && this.$store.state.user.email.includes('@pixxibook')) {
            console.log('impersonate user valu:', userinfo)
            this.$store.commit('updateDevMode',true)
            this.$store.commit('updateImpersonateUid',
                               Object.keys(userinfo)[0])
          }
        })
    }
  },
}
</script>

<style>
section {
    padding-top: 2em;
    padding-bottom: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/MyAccountPage.vue